import { get } from "api"
import { UserQuest } from "types/user/quest";


//获取用户任务列表
export const apiUserQuests = async (props:{type?:string}) =>
    await get<{}, UserQuest[]>(`/api/quest/list`,props);